import React from 'react'

function Profile() {
  return (
    <div className='Profile'>
        <div className='Profile-text'>
            <h1 style={{color: '#999'}}> Hello I'm </h1>
            <h1> Muhammad Usama Ali </h1>
            <h1 className='designation'> Front-End Developer </h1>
            <p> 
                As a front-end developer and Software Engineering student, 
                I am passionate about creating interactive web applications. 
                With expertise in HTML, CSS, JavaScript, and React.js, I 
                specialize in crafting responsive user interfaces that balance 
                aesthetics and functionality. My approach combines technical 
                skills with creative problem-solving, allowing me to deliver 
                innovative solutions. Committed to continuous learning, I am 
                eager to contribute to projects that enhance user experiences 
                and drive impactful results.
            </p>
            <div className='Resume-btn'>
                <a href="/Docs/Resume.pdf" target="_blank" rel='noreferrer'>
                    <button> Get My Resume </button>
                </a>
            </div>
        </div>
        <div className='Profile-Image'>
            <div className="Profile-Image-Container">
                <img src="./Pictures/pic.png" alt='Usama Ali'/>
            </div>
            <div className="Profile-Image-bg"></div>
        </div>
    </div>
  )
}

export default Profile;